import I18n from 'components/I18n'
import Money from 'components/Money'
import supportLink from 'constants/support'
import messages from 'lang'
import React from 'react'

import { BalanceContainer, LearnMoreLink, MaximumAmount } from './styles'

const Balance = ({
  mainAmount,
  mainCurrency,
  secondaryAmount,
  secondaryCurrency,
  setMaximumAmount
}) => {
  const showMoney = !!secondaryAmount && secondaryCurrency && mainCurrency !== secondaryCurrency

  return (
    <BalanceContainer data-e2e='withdrawableBalance'>
      <I18n data={messages.withdraw_balance} />.{' '}
      <LearnMoreLink
        href={`${supportLink}/en-us/articles/4417087718292-How-do-I-deposit-GBP-or-EUR-via-Instant-Transfers-with-Open-Banking-`}
        rel='noopener noreferrer'
        target='_blank'
      >
        <I18n data={messages.button_learn_more} />
      </LearnMoreLink>
      .
      <br />
      <MaximumAmount onClick={setMaximumAmount}>
        <Money amount={mainAmount} currency={mainCurrency} />
      </MaximumAmount>{' '}
      {showMoney && (
        <>
          (<Money amount={secondaryAmount} currency={secondaryCurrency} />)
        </>
      )}
    </BalanceContainer>
  )
}

export default Balance
